var React = require('react');

function UserIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M13.9997 0C8.65203 0 4.34766 4.30438 4.34766 9.65207C4.34766 14.9998 8.65203 19.3041 13.9997 19.3041C19.3474 19.3041 23.6518 14.9998 23.6518 9.65207C23.6518 4.30438 19.3474 0 13.9997 0V0ZM13.9997 16.3911C10.2606 16.3911 7.26059 13.3911 7.26059 9.65199C7.26059 5.9129 10.2606 2.91286 13.9997 2.91286C17.7388 2.91286 20.7389 5.9129 20.7389 9.65199C20.7389 13.3911 17.7388 16.3911 13.9997 16.3911Z","fill":"black","key":0}),React.createElement("path",{"d":"M13.9998 16.8691C6.2608 16.8691 0 23.13 0 30.869H2.47839C2.47839 24.5211 7.65201 19.3474 14 19.3474C20.348 19.3474 25.5216 24.5213 25.5216 30.869H28C28 23.1302 21.7391 16.8691 14.0002 16.8691H13.9998Z","fill":"black","key":1})]);
}

UserIcon.defaultProps = {"width":"28","height":"31","viewBox":"0 0 28 31","fill":"none"};

module.exports = UserIcon;

UserIcon.default = UserIcon;
